// tslint:disable
export var DocumentGroupSource;
(function (DocumentGroupSource) {
    // UNKN
    DocumentGroupSource[DocumentGroupSource["UNKN"] = 0] = "UNKN";
    // WEB
    DocumentGroupSource[DocumentGroupSource["WEB"] = 1] = "WEB";
    // InMail
    DocumentGroupSource[DocumentGroupSource["InMail"] = 2] = "InMail";
    // Infax
    DocumentGroupSource[DocumentGroupSource["Infax"] = 3] = "Infax";
    // Inemail
    DocumentGroupSource[DocumentGroupSource["Inemail"] = 4] = "Inemail";
    // FEED
    DocumentGroupSource[DocumentGroupSource["FEED"] = 5] = "FEED";
    // UPD
    DocumentGroupSource[DocumentGroupSource["UPD"] = 6] = "UPD";
    // OutMail
    DocumentGroupSource[DocumentGroupSource["OutMail"] = 7] = "OutMail";
    // OutFax
    DocumentGroupSource[DocumentGroupSource["OutFax"] = 8] = "OutFax";
    // OutEmail
    DocumentGroupSource[DocumentGroupSource["OutEmail"] = 9] = "OutEmail";
    // Mig
    DocumentGroupSource[DocumentGroupSource["Mig"] = 10] = "Mig";
    // Phone
    DocumentGroupSource[DocumentGroupSource["Phone"] = 11] = "Phone";
    // WebService
    DocumentGroupSource[DocumentGroupSource["WebService"] = 12] = "WebService";
    // DataFeed
    DocumentGroupSource[DocumentGroupSource["DataFeed"] = 13] = "DataFeed";
    // TCPortal
    DocumentGroupSource[DocumentGroupSource["TCPortal"] = 14] = "TCPortal";
    // SystemCreated
    DocumentGroupSource[DocumentGroupSource["SystemCreated"] = 15] = "SystemCreated";
    // Mail
    DocumentGroupSource[DocumentGroupSource["Mail"] = 16] = "Mail";
    // Fax
    DocumentGroupSource[DocumentGroupSource["Fax"] = 17] = "Fax";
    // Email
    DocumentGroupSource[DocumentGroupSource["Email"] = 18] = "Email";
    // SMS
    DocumentGroupSource[DocumentGroupSource["SMS"] = 19] = "SMS";
    // TCScript
    DocumentGroupSource[DocumentGroupSource["TCScript"] = 20] = "TCScript";
})(DocumentGroupSource || (DocumentGroupSource = {}));
DocumentGroupSource['INMAIL'] = 2;
DocumentGroupSource['INFAX'] = 3;
DocumentGroupSource['INEMAIL'] = 4;
DocumentGroupSource['OUTMAIL'] = 7;
DocumentGroupSource['OUTFAX'] = 8;
DocumentGroupSource['OUTEMAIL'] = 9;
DocumentGroupSource['MIG'] = 10;
DocumentGroupSource['PHONE'] = 11;
DocumentGroupSource['WEBSERVICE'] = 12;
DocumentGroupSource['DATAFEED'] = 13;
DocumentGroupSource['TCPORTAL'] = 14;
DocumentGroupSource['SYSTEMCREATED'] = 15;
DocumentGroupSource['MAIL'] = 16;
DocumentGroupSource['FAX'] = 17;
DocumentGroupSource['EMAIL'] = 18;
DocumentGroupSource['TCSCRIPT'] = 20;
//# sourceMappingURL=DocumentGroupSource.js.map